<template>
    <div class="text-nowrap">{{ formattedNumber }}</div>
  </template>
  
  <script>
  export default {
    name: "number-maker",
    props: {
      // Prop to toggle commas in the number format
      commas: {
        type: Boolean,
        default: false,
      },
      // Prop to specify the number of decimal places to round to
      decimals: {
        type: [Number, null],
        default: null,
      },
      // Prop for the currency symbol; if null, no symbol is displayed
      currency: {
        type: String,
        default: null,
      },
      // The number to be formatted
      number: {
        type: Number,
        required: true,
      },
      // Prop to toggle the percentage sign
      percentage: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      formattedNumber() {
        let number = this.number;
  
        // Handle rounding
        if (this.decimals !== null) {
          number = number.toFixed(this.decimals);
        }
  
        // Add commas if required
        let numberWithCommas = number;
        if (this.commas) {
          const parts = number.toString().split(".");
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          numberWithCommas = parts.join(".");
        }
  
        // Add currency symbol if provided
        let formatted = this.currency ? `${this.currency} ${numberWithCommas}` : numberWithCommas;
  
        // Append percentage sign if required
        if (this.percentage) {
          formatted += " %";
        }
  
        return formatted;
      },
    },
  };
  </script>
  
  <style>
  /* Add any styling here if needed */
  </style>
  